module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Biberstein-e48f6a37da54966980af33f098aeb8dc.svg";